import { FormValues, NewApplicationListItem } from '../../types';

const updateApplicationValues = ({
  values,
  info,
}: {
  values: FormValues;
  info: NewApplicationListItem;
}) => {
  const stepOne = {
    firstName: values.firstName,
    lastName: values.lastName,
    phone: values.phone,
    email: values.email,
    dob: values.dob,
    soureOfFundsIds: values.sourceOfFundsIds,
    clientActivityId: values.clientActivityId,
    deliveryChannelId: values.deliveryChannelId,
    sourceOfFundsDescription: values.sourceOfFundsDescription || '',
    typeOfActivityDescription: values.typeOfActivityDescription || '',
    nameOfEmployer: values.nameOfEmployer || '',
    employeePosition: values.employeePosition || '',
    countryOfEmployerId: values.countryOfEmployerId || '',
  };

  const currentMontlyVolumes = {
    monthlyTurnoverRangeId: values.monthlyTurnoverRangeId,
    monthlyNumberIncomingTransactionsRangeId:
      values.monthlyNumberIncomingTransactionsRangeId,
    monthlyNumberOutgoingTransactionsRangeId:
      values.monthlyNumberOutgoingTransactionsRangeId,
    monthlyValueIncomingTransactionsRangeId:
      values.monthlyValueIncomingTransactionsRangeId,
    monthlyValueOutgoingTransactionsRangeId:
      values.monthlyValueOutgoingTransactionsRangeId,
    monthlyMaxValueIncomingPaymentRangeId:
      values.monthlyMaxValueIncomingPaymentRangeId,
    monthlyMaxValueOutgoingPaymentRangeId:
      values.monthlyMaxValueOutgoingPaymentRangeId,
  };

  const currentStepThree = {
    countryId: values.countryId,
    city: values.city,
    postalCode: values.postalCode,
    address1: values.address1,
    address2: values.address2,
    passportNumber: values.passportNumber,
    passportExpiredDate: values.passportExpiredDate,
    participatesInPolitics: values.participatesInPolitics,
    isUSResident: values.isUSResident,
  };

  const stepTwo = {
    ...currentMontlyVolumes,
    productIds: values.productIds,
  };

  const stepThree = {
    sumSubStatus: info.sumSubApplication.reviewStatus,
    ...currentStepThree,
  };

  const nextInfo = {
    ...info,
    ...stepOne,
    ...stepTwo,
    ...stepThree,
  };

  return nextInfo;
};

export default updateApplicationValues;
